<template>
	<v-container>
		<v-app-bar app>
			<div class="d-flex d-lg-none">
				<v-app-bar-nav-icon
					@click.stop="$emit('drawer-change')"
				></v-app-bar-nav-icon>
			</div>
			<v-toolbar-title>Página não encontrada</v-toolbar-title>
		</v-app-bar>
		<v-row>
			<v-col cols="12" height="1000">
				<v-card tile>
					<v-card-title primary-title v-if="$route.query.triedUrl">
                        A página {{$route.query.triedUrl}} não pôde ser encontrada.
                    </v-card-title>
					<v-card-title primary-title v-else>
						A página {{$route.path}} não pôde ser encontrada.
					</v-card-title>
					
				</v-card>
			</v-col>
			<v-col></v-col>
		</v-row>
	</v-container>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {

};
</script>
